import { ArtistData } from "../../artist/interfaces/dto";

export function buildArtistOutput(
	artist: ArtistData,
	wrapper: HTMLElement,
	gridItemToClone: HTMLElement,
) {
	const item = gridItemToClone.cloneNode(true) as HTMLElement;

	const imageLink: HTMLAnchorElement | null = item.querySelector(
		".artist-list-item-header",
	);

	if (imageLink) {
		imageLink.href = artist.profileUrl;
		imageLink.style.backgroundImage = "url(" + artist.latestPhotoUrl + ")";
	}

	const displayNameEl: HTMLElement | null = item.querySelector("p strong");

	if (displayNameEl) {
		displayNameEl.textContent = artist.displayName;
	}

	const photosCountEl: HTMLElement | null =
		item.querySelector(".photo-count");

	if (photosCountEl) {
		photosCountEl.textContent = artist.totalPhotos.toString();
	}

	const photoLocationEl: HTMLElement | null =
		item.querySelector(".photo-location");

	if (photoLocationEl) {
		photoLocationEl.innerHTML = artist.location;
	}

	const viewProfileLink: HTMLAnchorElement | null = item.querySelector("p a");

	if (viewProfileLink) {
		viewProfileLink.href = artist.profileUrl;
	}

	const followButton: HTMLElement | null =
		item.querySelector(".follow-action");

	if (followButton) {
		const buttonTextEl: HTMLElement | null =
			followButton.querySelector(".button-text");

		if (wrapper.dataset.useFollowingStatus) {
			followButton.dataset.userId = artist.id.toString();
			followButton.dataset.actionType = artist.isFollowing
				? "unfollow"
				: "follow";

			if (buttonTextEl) {
				buttonTextEl.textContent = artist.isFollowing ? "Following" : "Follow";
			}

			if (artist.isFollowing) {
				followButton.classList.add("is-active");
			} else {
				followButton.classList.remove("is-active");
			}
		}
	}

	const masonryBreak: HTMLElement | null =
		wrapper.querySelector(".flexmasonry-break");

	if (masonryBreak) {
		wrapper.insertBefore(item, masonryBreak);
	} else {
		wrapper.appendChild(item);
	}
}
